<div class="logo">
    <a href="" class="simple-text logo-normal">
        Sistema ALERTA
    </a>
</div>
<div class="sidebar-wrapper">
    <ul class="nav">
        <app-sidebar-grupo *ngFor="let grupo of grupos" [grupo]="grupo"></app-sidebar-grupo>
    </ul>
</div>